import React, { Fragment, useState, useCallback } from 'react';
import {
    Button,
    CssBaseline,
    TextField,
    Link,
    Grid,
    Typography,
} from '@material-ui/core';
import {
    makeStyles,
    createStyles,
    withStyles,
    WithStyles,
} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useCookies } from 'react-cookie';
import { useHistory } from 'react-router-dom';
import { useLongPress } from 'use-long-press';
//import LongPressable from 'react-longpressable';
import ToastStr from '../request/toastStr';

import axios from 'axios';

import { COLORS } from './Theme';
import { SIcon } from './Icon';

import {
    member as v_member,
    basic,
    Values,
    SNACKBAR_TIME,
} from '../request/values';
import { useSnackbar } from 'notistack';

import './mediaCss.css';

import useCommonStyles from './commonStyles/headerEmpty/useCommonStyles';

const SERVER = basic.server;

const useStyles = makeStyles((theme: any) => ({
    wrapper: {
        padding: '9vh 1vw',
        [theme.breakpoints.up('md')]: {
            padding: '0',
        },
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    submit: {
        height: '50px',
        margin: theme.spacing(3, 0, 2),
        borderRadius: '27px',
        boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: 'solid 0.5px #cfd4d9',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        '&:hover': {
            backgroundColor: `${COLORS.WATER_BLUE}`,
        },
    },
    submit2: {
        height: '50px',
        borderRadius: '27px',
        boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: 'solid 0.5px #cfd4d9',
        color: `${COLORS.WATER_BLUE}`,
        backgroundColor: `${COLORS.WHITE}`,
        '&:hover': {
            backgroundColor: `${COLORS.WHITE}`,
        },
    },
    submitButton: {
        '& :hover': {
            backgroundColor: `${COLORS.WATER_BLUE}`,
        },
    },
    logoSection: {
        // position: 'absolute',
        // bottom: '5vh',
        // width: '100vw',
        // textAlign: 'center'
        display: 'flex',
        justifyContent: 'center',
        flex: 1,
        alignItems: 'flex-end',
        marginTop: '12vh',
        paddingBottom: '10vh',
    },
    logobutton: {
        border: 'none',
        backgroundColor: 'transparent',
    },
}));

// interface LoginProps {
//   setMember: Dispatch<SetStateAction<Function>>,
// }

const LoginIn: React.FC<any> = (props) => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();

    const [member_email, setEmail] = useState<string | null>();
    const [member_password, setPassword] = useState<any | null>();
    const history = useHistory();
    const [cookies, setCookie, removeCookie] = useCookies();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const { member, setMember, token } = props;

    // const dispatch = useDispatch()
    // const member = useSelector((state:RootState) => state.memberReducer);

    // const action = (key: any) => (
    //   <Fragment>
    //     <Button onClick={() => { closeSnackbar(key) }}>
    //       Close
    //     </Button>
    //   </Fragment>
    // );

    const handleLogin = (member: any) => {
        console.log('in Login handleLogin', member);
        if (member) {
            if (member.classCode === null || member.classCode.length == 0) {
                history.push({
                    pathname: '/ClassEnter',
                });
            } else if (member.companyNum === -1) {
                history.push({
                    pathname: '/CompanyAppStandBy',
                });
            } else if (member.companyNum === 0 || member.companyNum === null) {
                history.push({
                    pathname: '/CompanyAction',
                });
            } else {
                history.push({
                    pathname: '/CompanyInfo',
                });
            }
        }
    };

    const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;

        if (id == 'member_email') setEmail(value);
        else setPassword(value);
    };

    const submitHandler = (event: any) => {
        axios({
            method: 'POST',
            data: {
                email: member_email,
                password: member_password,
                token: token,
            },
            withCredentials: true,
            url: SERVER + v_member.member + v_member.login,

            headers: {
                'Access-Control-Allow-Origin': basic.server_url,
                mode: 'cors',
                'Access-Control-Allow-Headers':
                    'Origin, X-Requested-With, Content-Type, Accept',
            },
        })
            .then((res) => {
                console.log('res?', res);

                return res.data;
            })
            .then((data: any) => {
                // console.log('data?', data)
                if (data.code == Values.FAIL_CODE) {
                    enqueueSnackbar(ToastStr.LOGIN_FAIL, {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else {
                    //setCookie('access', data.jwt);
                    // axios.defaults.headers.common[
                    //     'Authorization'
                    // ] = `Bearer ${data.jwt}`;
                    setMember(data.member);
                    handleLogin(data.member);

                    if (window.ReactNativeWebView) {
                        console.log('to rn!!', data.member.id);
                        window.ReactNativeWebView.postMessage(data.member.id);
                    }
                    // window.postMessage(data.member.id, '*')
                }
            })
            .catch((error: any) => {
                if (error.response) {
                    console.log('error?', error.response);
                    if (error.response.status == 400) {
                        enqueueSnackbar(ToastStr.LOGIN_FAIL, {
                            variant: 'error',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                    } else if (error.response.status == 401) {
                        enqueueSnackbar(ToastStr.PWD_CHECK_FALSE_STR, {
                            variant: 'error',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                    }
                }
            });
    };

    const moveOperator = () => {
        history.push('/operation');
    };

    const moveEmail = () => {
        history.push('/authAll');
        //window.location.replace("/email")
        //window.location.replace("/email") 새로 고쳐서 오류 해결하는 부분
    };

    const findPassword = () => {
        history.push('/findPassword');
    };

    const buttonToOper = useLongPress(moveOperator, {
        threshold: 3000,
        captureEvent: true,
        cancelOnMovement: false,
    });

    return (
        <div className={classes.wrapper}>
            <div className={commonClasses.paper}>
                <div className={commonClasses.titleLeft}>
                    플레이 스타트업에
                    <br />
                    오신 것을 환영합니다!
                </div>
                <div className={commonClasses.form}>
                    <TextField
                        variant="standard"
                        margin="normal"
                        required
                        fullWidth
                        id="member_email"
                        label="ID"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={member_email}
                        onChange={valueChangeHandler}
                        InputProps={{ className: commonClasses.inputProps }}
                        InputLabelProps={{
                            className: commonClasses.inputLabel,
                        }}
                        style={{ color: `${COLORS.BLACK}` }}
                    />
                    <TextField
                        variant="standard"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="PASSWORD"
                        type="password"
                        id="member_password"
                        autoComplete="current-password"
                        value={member_password}
                        onChange={valueChangeHandler}
                        InputProps={{
                            className: commonClasses.passwordInputProps,
                        }}
                        InputLabelProps={{
                            className: commonClasses.inputLabel,
                        }}
                        style={{ color: `${COLORS.BLACK}` }}
                    />
                    {/* <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
          /> */}
                    <Button
                        // type="submit"
                        fullWidth
                        variant="contained"
                        className={classes.submit}
                        onClick={(e) => submitHandler(e)}
                    >
                        <Typography variant="h3">로그인하기</Typography>
                    </Button>
                    <Button
                        fullWidth
                        variant="contained"
                        className={classes.submit2}
                        onClick={moveEmail}
                    >
                        <Typography
                            variant="h3"
                            style={{ color: `${COLORS.WATER_BLUE}` }}
                        >
                            회원가입하기
                        </Typography>
                    </Button>

                    <Grid container justify="center">
                        <Grid item>
                            <Button
                                onClick={findPassword}
                                style={{ marginTop: '2vh' }}
                            >
                                <Typography
                                    style={{
                                        color: `${COLORS.DOWN}`,
                                        fontSize: '16px',
                                    }}
                                >
                                    비밀번호 변경하기
                                </Typography>
                            </Button>
                        </Grid>
                        {/* <Grid item>
                <Button onClick ={findPassword}>
                  <Typography variant="h2" style={{ color: `${COLORS.DOWN}` }}>
                    비밀번호찾기
                  </Typography>
                </Button>
              </Grid> */}
                    </Grid>
                </div>
                <div className={classes.logoSection}>
                    <button {...buttonToOper} className={classes.logobutton}>
                        <SIcon type="P" />
                    </button>
                </div>
            </div>
        </div>
    );
};
/*

        <div className={classes.logoSection}>
        <button {...bind}>
            <SIcon type="P" />
            </button>
        </div>


        <div className={classes.logoSection}>
        <LongPressable
            onLongPress={() => moveOperator()}
            longPressTime={3000}
            >
            <SIcon type="P" />
            </LongPressable>
        </div>
*/
// function Copyright() {
//   return (
//     <Typography variant="body2" color="textSecondary" align="center">
//       {'Copyright © '}
//       <Link color="inherit" href="http://mittelstand.co.kr/">
//         Mittelstand
//       </Link>{' '}
//       {new Date().getFullYear()}
//       {'.'}
//     </Typography>
//   );
// }

export default LoginIn;

// const useStyles = (theme: Theme) =>
//     createStyles({
//     paper: {
//         marginTop: theme.spacing(8),
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//     },
//     avatar: {
//         margin: theme.spacing(1),
//         backgroundColor: theme.palette.secondary.main,
//     },
//     form: {
//         width: '100%', // Fix IE 11 issue.
//         marginTop: theme.spacing(1),
//     },
//     submit: {
//         margin: theme.spacing(3, 0, 2),
//     },
// });

// interface SigInProps extends WithStyles<typeof useStyles> {
//     setMember: (m:iMember)=>void,
// }

// interface SignInState {
//     member_email: string | undefined | null,
//     member_password: string | undefined | null,
//     isLoggedIn: boolean | string,
// }

// class SignIn extends React.Component<SigInProps, SignInState> {
//     constructor(props: SigInProps) {
//         super(props);
//         this.state = {
//             member_email: undefined,
//             member_password: undefined,
//             isLoggedIn: false,
//         }

//         this.valueChangeHandler = this.valueChangeHandler.bind(this);
//         this.submitHandler = this.submitHandler.bind(this);
//     }

//     valueChangeHandler(e: React.ChangeEvent<HTMLInputElement>) {
//         const {id, value} = e.target;
//         let stateId:string = "member_" + id;

//         this.setState({ [id]: value } as Pick<SignInState, keyof SignInState>);
//     }

//     submitHandler = (event:any) => {
//         event.preventDefault();
//         const requestOption = {
//             method: 'POST',
//             headers: {
//                 "Content-Type": "application/json; charset=utf-8"
//             },
//             body: JSON.stringify({
//                 'email': this.state.member_email,
//                 'password': this.state.member_password
//             })
//         }
//         console.log('in submitHandler')
//         fetch('http://localhost:3001/v3/member/login', requestOption)
//             .then((res) => {
//                 return res.json()
//             }).then((data)=> {
//                 console.log(data)
//                 if (data.code == '9400') {
//                     alert('Login Failed!')
//                 } else {
//                     this.props.setMember(data.member);
//                     // this.setState({
//                     //     isLoggedIn: true,
//                     // })
//                 }
//             })
//     }

//     render() {
//         const { classes } = this.props;

//         return (
//             <Container component="main" maxWidth="xs">
//                 <CssBaseline />
//                 <div className={classes.paper}>
//                     <Avatar className={classes.avatar}>
//                         <LockOutlinedIcon />
//                     </Avatar>
//                     <Typography component="h1" variant="h5">
//                         Sign in
//                     </Typography>
//                     <form className={classes.form} onSubmit={this.submitHandler} noValidate>
//                         <TextField
//                             variant="outlined"
//                             margin="normal"
//                             required
//                             fullWidth
//                             id="member_email"
//                             label="Email Address"
//                             name="email"
//                             autoComplete="email"
//                             autoFocus
//                             value={this.state.member_email}
//                             onChange={this.valueChangeHandler}
//                         />
//                         <TextField
//                             variant="outlined"
//                             margin="normal"
//                             required
//                             fullWidth
//                             name="password"
//                             label="Password"
//                             type="password"
//                             id="member_password"
//                             autoComplete="current-password"
//                             value={this.state.member_password}
//                             onChange={this.valueChangeHandler}
//                         />
//                         <FormControlLabel
//                             control={<Checkbox value="remember" color="primary" />}
//                             label="Remember me"
//                         />
//                         <Button
//                             type="submit"
//                             fullWidth
//                             variant="contained"
//                             color="primary"
//                             className={classes.submit}
//                         >
//                             Sign In
//                         </Button>
//                         <Grid container>
//                             <Grid item xs>
//                                 <Link href="#" variant="body2">
//                                     Forgot password?
//                                 </Link>
//                             </Grid>
//                             <Grid item>
//                                 <Link href="#" variant="body2">
//                                     {"Don't have an account? Sign Up"}
//                                 </Link>
//                             </Grid>
//                         </Grid>
//                     </form>
//                 </div>
//                 <Box mt={8}>
//                     <Copyright />
//                 </Box>
//             </Container>
//         )
//     }
// }

// export default withStyles(useStyles)(SignIn);
// export default connect((isAuthUser => ({isAuthUser})))(withStyles(useStyles)(SignIn));
